import React from 'react'
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Grid,
  Modal,
  Stack,
  Typography,
  useMediaQuery
} from '@mui/material'
import { theme } from '../../../theme/DashboardTheme'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTipSharp';
import Cookies from 'universal-cookie';
interface CompleteFamilyPlanProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const CompleteFamilyPlan = (props: CompleteFamilyPlanProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()
  const cookie = new Cookies()
  const onClose=(navigateToPlusOne: boolean)=>{
    cookie.set('PromptForFamilyPlan', 'false', {
      path: '/',
      maxAge: 60 * 60 * 24 * 365 * 100,
    });
    props.setOpen(false)
    if(navigateToPlusOne){
      navigate('/dashboard/profile', { state: { index: 3 } });
    }
  }

  return (
    <Modal
      open={props.open}
      sx={{
        backdropFilter: 'blur(5px)',
        background: 'rgba(0, 0, 0, 0.01)',
      }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '600px',
          transform: 'translate(-50%, -50%)',
          width: !isMobile ? '30%' : '80%',
          background: '#fff',
          p: {xs: 5, sm: 6, md: 8},
          borderRadius: '10px',
        }}>
        <Stack justifyContent="center" alignItems="center" flexDirection={'column'}>
          <div style={{ fontSize: '90px', alignItems:'center', height:'90px' }}>
            <PrivacyTipIcon fontSize='inherit' htmlColor='#C67EFF'/>
          </div>
           <Typography 
                variant="h2"
                mt={5} 
                textAlign="center"
                sx={{
                    fontSize: {xs: 18, md: 21, lg: 23},
                    fontWeight: 600,
                    lineHeight: {xs: 1, md: 1.2, lg: 1.5},
                }}>
                Your Family plan is almost set up! 
            </Typography>
          <Typography
            mt={2} 
            variant="body2" 
            textAlign="center" 
            color={'#615F6B'}
            sx={{
              fontSize: {xs: 12, md: 14, lg: 16},
              lineHeight: {xs: 1.2, md: 1.2, lg: 1.5},
              letterSpacing : '0'
            }}>
            Add a plus-one to get the most out of your subscription.
          </Typography>
        </Stack>
        <Grid item xs={12} sm={12} justifyContent="center" display="flex">
          <Button
            variant={'contained'}
            onClick={()=>{onClose(true)}}
            sx={{
              width: {xs: '90%', sm: '100%', lg: '63%'},
              borderRadius: '10px',
              mt : 4,
              mb : 2,
              fontSize: {xs: 8, md: 13, lg: 14},
              boxShadow: 'unset',
              border: '2px solid #C67EFF',
              background: '#C67EFF',
              color: '#fff',
              '&.Mui-disabled': {
                background: '#C67EFF',
                color: '#fff',
              },
              ':hover': {
                background: '#C67EFF',
                color: '#fff',
              },
            }}>
            Add a plus one
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} justifyContent="center" display="flex">
          <Button
            variant={'contained'}
            color={'darkPurple'}
            onClick={()=>{onClose(false)}}
            sx={{
              width: {xs: '90%', sm: '100%', lg: '63%'},
              borderRadius: '10px',
              fontSize: {xs: 8, md: 13, lg: 14},
              boxShadow: 'unset',
              border: '2px solid #C67EFF',
              background: 'transparent',
              color: '#C67EFF',
              '&.Mui-disabled': {
                background: 'transparent',
                color: '#C67EFF',
              },
              ':hover': {
                background: 'transparent',
                color: '#C67EFF',
              },
            }}>
            Skip & Continue
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default CompleteFamilyPlan 